export default __webpack_public_path__ + "static/media/Slide3.a1a8056f.jpeg";